window.addEventListener("DOMContentLoaded", function() {
  var isReload = false;
  if (performance.getEntriesByType) {
    var nav = performance.getEntriesByType("navigation")[0];
    if (nav && nav.type === "reload") isReload = true;
  }
  if (!isReload && performance.navigation && performance.navigation.type === 1) {
    isReload = true;
  }
  if (isReload) window.scrollTo(0, 0);
});


/*! For license information please see saros10_main.js.LICENSE.txt */ ! function() {
    var e = {
            "./src/js/main.js": function(e, t, s) {
                "use strict";
                var i = s("./src/widgets/gsap-sequence.js"),
                    o = s("./src/widgets/debug.js"),
                    n = s("jquery");
                (0, o.debugfunction)();
                var c = document.documentElement.clientHeight || window.innerHeight,
                    r = document.documentElement.clientWidth || window.innerWidth,
                    a = r < 750,
                    p = getComputedStyle(document.documentElement).getPropertyValue("--body-font-size");
                n(window).scrollTop();

                function l(e) {
                    gsap.timeline({
                        yoyo: !0,
                        scrollTrigger: {
                            trigger: n(n.CN("".concat(e, " .top-line"))),
                            start: "top bottom-=".concat(a ? "5%" : "10%"),
                            end: "top center-=".concat(a ? "0" : "20%"),
                            scrub: !0
                        }
                    }).to(n.CN("".concat(e, " .top-line svg")), {
                        opacity: 1
                    })
                }

                function g(e) {
                    ScrollTrigger.create({
                        trigger: n(n.CN("".concat(e, " .card"))),
                        start: "top bottom-=10%",
                        end: "top bottom-=10%",
                        scrub: !0,
                        onEnter: function() {
                            n(n.CN("".concat(e, " .card .light-line"))).addClass(n.CN("active"))
                        },
                        onEnterBack: function() {
                            n(n.CN("".concat(e, " .card .light-line"))).removeClass(n.CN("active"))
                        }
                    })
                }

                function d(e) {
                    ScrollTrigger.create({
                        trigger: n(n.CN("".concat(e, " ").concat(a ? ".EQ-MOB" : ".EQ-PC").concat(n.CN(".bottom-line")))),
                        start: "top bottom-=10%",
                        end: "top bottom-=10%",
                        scrub: !0,
                        onEnter: function() {
                            n(n.CN("".concat(e, " .bottom-line"))).addClass(n.CN("active"))
                        },
                        onEnterBack: function() {
                            n(n.CN("".concat(e, " .bottom-line"))).removeClass(n.CN("active"))
                        }
                    })
                }

                function m(e) {
                    var t = n(e).children()[0],
                        s = n(t).children()[1],
                        i = n(t).children()[2],
                        o = n(t).children()[3],
                        c = .2;
                    return gsap.timeline({
                        repeat: 3,
                        paused: !0,
                        repeatDelay: .1
                    }).to(n(s), {
                        width: a ? "105%" : "103%",
                        height: a ? "120%" : "130%",
                        duration: c
                    }).to(n(s), {
                        borderColor: "transparent",
                        width: a ? "108%" : "106%",
                        height: a ? "140%" : "160%",
                        duration: c
                    }).to(n(i), {
                        width: a ? "105%" : "103%",
                        height: a ? "120%" : "130%",
                        duration: c
                    }, "<").to(n(i), {
                        borderColor: "transparent",
                        width: a ? "108%" : "106%",
                        height: a ? "140%" : "160%",
                        duration: c
                    }, ">").to(n(o), {
                        width: a ? "105%" : "103%",
                        height: a ? "120%" : "130%",
                        duration: c
                    }, "<").to(n(o), {
                        borderColor: "transparent",
                        width: a ? "108%" : "106%",
                        height: a ? "140%" : "160%",
                        duration: c
                    }, ">")
                }

                function u() {
                    if (a) {
                        var e = new Swiper("".concat(n.CN(".section-sixteen"), " .swiper"), {
                            direction: "horizontal",
                            loop: !0,
                            loopedSlides: 4,
                            slidesPerView: "auto",
                            centeredSlides: !0,
                            autoplay: {
                                duration: 3
                            },
                            spaceBetween: 20,
                            pagination: {
                                el: "".concat(n.CN(".section-sixteen"), " .swiper-pagination"),
                                clickable: !0,
                                bulletClass: n.CN("m-swiper-pagination-bullet"),
                                bulletActiveClass: n.CN("m-swiper-pagination-bullet-active")
                            },
                            on: {
                                slideChangeTransitionStart: function(e) {
                                    var t = e.realIndex;
                                    n(n.CN(".section-sixteen .main-card-mob .label")).removeClass(n.CN("active")), n(n.CN(".section-sixteen .main-card-mob .tip")).removeClass(n.CN("active")), n(n.CN(".section-sixteen .main-card-mob .label:nth-child(".concat(t + 1, ")"))).addClass(n.CN("active")), n(n.CN(".section-sixteen .main-card-mob .tip:nth-child(".concat(t + 1, ")"))).addClass(n.CN("active"))
                                }
                            }
                        });
                        e.autoplay.stop(), ScrollTrigger.create({
                            trigger: n("".concat(n.CN(".section-sixteen"), " .swiper")),
                            start: "top center-=10%",
                            end: "bottom center-=10%",
                            scrub: !0,
                            onEnter: function() {
                                e.autoplay.start()
                            },
                            onEnterBack: function() {
                                e.autoplay.start()
                            },
                            onLeave: function() {
                                e.autoplay.stop()
                            },
                            onLeaveBack: function() {
                                e.autoplay.stop()
                            }
                        }), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-sixteen .bottom-card-mob")),
                                start: "top center-=10%",
                                end: "top top",
                                scrub: !0
                            }
                        }).to(n(n.CN(".section-sixteen .bottom-card-mob .title")), {
                            color: "white"
                        }).to(n(n.CN(".section-sixteen .bottom-card-mob")), {
                            border: "1px solid #434347",
                            boxShadow: "0px 0px 20px 3px #525252 inset"
                        }, "<").to(n(n.CN(".section-sixteen .bottom-card-mob .desc")), {
                            opacity: 1
                        }, "<").to(n(n.CN(".section-sixteen .bottom-card-mob img")), {
                            opacity: 1
                        }, "<")
                    } else {
                        var t = function() {
                                o && clearInterval(o), o = setInterval((function() {
                                    i < 4 ? i++ : i = 1, s()
                                }), 3e3)
                            },
                            s = function() {
                                n(n.CN(".section-sixteen .main-card .label")).removeClass(n.CN("active")), n(n.CN(".section-sixteen .main-card .label:nth-child(".concat(i, ")"))).addClass(n.CN("active")), n(n.CN(".section-sixteen .main-card .progress")).css({
                                    top: .7 * p * (i - 1) + .045 * p + "px"
                                }), n(n.CN(".section-sixteen .main-card .tip")).removeClass(n.CN("pre")), n(n.CN(".section-sixteen .main-card .tip:nth-child(".concat(i - 1 > 0 ? i - 1 : 4, ")"))).addClass(n.CN("pre")), n(n.CN(".section-sixteen .main-card .tip")).removeClass(n.CN("active")), n(n.CN(".section-sixteen .main-card .tip:nth-child(".concat(i, ")"))).addClass(n.CN("active")), n(n.CN(".section-sixteen .main-card .right img")).removeClass(n.CN("active")), n(n.CN(".section-sixteen .main-card .right img:nth-child(".concat(i, ")"))).addClass(n.CN("active"))
                            };
                        gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-sixteen .sticky-back")),
                                start: "top top",
                                end: "center+=10% bottom",
                                scrub: !0
                            }
                        })
                        // .to(n(n.CN(".section-sixteen .bottom-card .hide")), {
                        //     opacity: 0
                        // }).to(n(n.CN(".section-sixteen .bottom-card .hide-title")), {
                        //     color: "transparent"
                        // }, "<").to(n(n.CN(".section-sixteen .bottom-card")), {
                        //     border: "1px solid transparent",
                        //     boxShadow: "0px 0px 20px 3px transparent inset"
                        // }, "<").to(n(n.CN(".section-sixteen .bottom-card .light-text")), {
                        //     opacity: 1
                        // }, ">");
                        var i = 1,
                            o = null;
                        ScrollTrigger.create({
                            trigger: n(n.CN(".section-sixteen .main-card")),
                            start: "top center",
                            end: "top center",
                            scrub: !0,
                            onEnter: function() {
                                t()
                            },
                            onEnterBack: function() {
                                o && clearInterval(o), i = 1, s()
                            }
                        }), n(n.CN(".section-sixteen .main-card .label")).on("click", (function(e) {
                            i = e.currentTarget.dataset.index, s(), t()
                        }))
                    }
                }
                n(window).on("resize", (function(e) {})), n(document).ready((function() {
                    var e, t, s, o, b, f, _, C, h, v;
                    n(n.CN(".fadein-up")).each((function() {
                            gsap.set(n(this), {
                                opacity: 0,
                                y: 60
                            }), gsap.fromTo(n(this), {
                                y: 60,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power2.easeOut",
                                immediateRender: !0,
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top-=".concat(a ? "60px" : "0", " bottom-=") + "15%",
                                    end: "top-=".concat(a ? "60px" : "0", " bottom-=") + "15%",
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                delay: Number(n(this).attr("delay")) || 0
                            })
                        })), n(n.CN(".light")).each((function() {
                            gsap.timeline({
                                yoyo: !0,
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "center bottom-=".concat(a ? "10%" : "0"),
                                    end: "center center",
                                    scrub: !0
                                }
                            }).to(n(this), {
                                opacity: 1
                            })
                        })), n(n.CN(".red-line")).each((function() {
                            var e = this;
                            ScrollTrigger.create({
                                trigger: n(this),
                                start: "top bottom-=".concat(a ? "15%" : "20%"),
                                end: "top bottom-=".concat(a ? "15%" : "20%"),
                                scrub: !0,
                                onEnter: function() {
                                    n(e).addClass(n.CN("active"))
                                },
                                onEnterBack: function() {
                                    n(e).removeClass(n.CN("active"))
                                }
                            })
                        })), n(n.CN(".product-content .video-loop")).on("ended", (function(e) {
                            setTimeout((function() {
                                e.target.play()
                            }), 1e3)
                        })), n(n.CN(".section-first video".concat(a ? n.CN(".EQ-MOB") : n.CN(".EQ-PC")))).get(0).addEventListener("ended", (function() {
                            $('.fv_area').addClass('active');
                            // setTimeout(function(){
                            //     window.dispatchEvent(new Event('resize'));
                            //     console.log('RESIZE???')
                            // },500);
                            n(n.CN(".section-first .kv-img".concat(a ? n.CN(".EQ-MOB") : n.CN(".EQ-PC")))).css({
                                opacity: 1
                            })
                        })), n(n.CN(".option2-btn-main")).on("click", (function() {
                            console.log(123123), n("".concat(n.CN(".section-eighteen")).concat(n.CN(".mask-back"))).css({
                                zIndex: "10",
                                opacity: "1"
                            })
                        })), l(".section-forth"), l(".section-sixth .top-block"), g(".section-sixth"), d(".section-sixth"), e = m(n(n.CN(".section-eighth .sticky .btn-back"))), ScrollTrigger.create({
                            trigger: n(n.CN(".section-eighth .sticky-back .sticky")),
                            start: "top bottom",
                            end: "bottom top",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-eighth .sticky .btn-back .btn")).css({
                                    borderColor: "#5063b0"
                                }), e.restart()
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-eighth .sticky .btn-back .btn")).css({
                                    borderColor: "#5063b0"
                                }), e.restart()
                            },
                            onLeave: function() {
                                e.revert(), n(n.CN(".section-eighth .sticky .btn-back .btn")).css({
                                    borderColor: "transparent"
                                })
                            },
                            onLeaveBack: function() {
                                e.revert(), n(n.CN(".section-eighth .sticky .btn-back .btn")).css({
                                    borderColor: "transparent"
                                })
                            }
                        }), n(n.CN(".section-eighth .sticky .btn-back .first")).on("click", (function() {
                            n("".concat(n.CN(".section-seventeen")).concat(n.CN(".mask-back"))).css({
                                zIndex: "10",
                                opacity: "1"
                            })
                        })), n(n.CN(".section-seventeen .close")).on("click", (function() {
                            n("".concat(n.CN(".section-seventeen")).concat(n.CN(".mask-back"))).css({
                                opacity: "0",
                                zIndex: "-2"
                            })
                        })), ScrollTrigger.create({
                            trigger: n(n.CN(".section-ninth")),
                            start: "top bottom",
                            end: "bottom top",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-zero")).css("opacity", "1")
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-zero")).css("opacity", "1")
                            },
                            onLeave: function() {
                                n(n.CN(".section-zero")).css("opacity", "0")
                            },
                            onLeaveBack: function() {
                                n(n.CN(".section-zero")).css("opacity", "0")
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-ninth")),
                            start: "top center-=20%",
                            end: "top center-=20%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-zero .red-line2")).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-zero .red-line2")).removeClass(n.CN("active"))
                            }
                        }), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-ninth")),
                                start: "top center-=20%",
                                end: "top top",
                                scrub: !0
                            }
                        }).fromTo(n(n.CN(".section-zero .light2")), {
                            opacity: 0
                        }, {
                            opacity: 1
                        }), g(".section-eleventh"), l(".section-thirteen .top-block"), g(".section-thirteen"),
                        function() {
                            a ? (ScrollTrigger.create({
                                trigger: n(n.CN(".section-fifteen .back-box .content-box")),
                                start: "top center",
                                end: "top center",
                                scrub: !0,
                                onEnter: function() {
                                    n(n.CN(".section-fifteen .left .red-line2")).addClass(n.CN("active"))
                                },
                                onEnterBack: function() {
                                    n(n.CN(".section-fifteen .left .red-line2")).removeClass(n.CN("active"))
                                }
                            }), ScrollTrigger.create({
                                trigger: n(n.CN(".section-fifteen .back-box .content-box .right")),
                                start: "top bottom-=20%",
                                end: "top bottom-=20%",
                                scrub: !0,
                                onEnter: function() {
                                    n(n.CN(".section-fifteen .right .red-line2")).addClass(n.CN("active"))
                                },
                                onEnterBack: function() {
                                    n(n.CN(".section-fifteen .right .red-line2")).removeClass(n.CN("active"))
                                }
                            })) : ScrollTrigger.create({
                                trigger: n(n.CN(".section-fifteen .back-box .content-box")),
                                start: "top center",
                                end: "top center",
                                scrub: !0,
                                onEnter: function() {
                                    n(n.CN(".section-fifteen .red-line2")).addClass(n.CN("active"))
                                },
                                onEnterBack: function() {
                                    n(n.CN(".section-fifteen .red-line2")).removeClass(n.CN("active"))
                                }
                            });
                            var e = m(n(n.CN(".section-fifteen .sticky .btn-back")));
                            ScrollTrigger.create({
                                trigger: n(n.CN(".section-fifteen .section-content .sticky")),
                                start: "top bottom",
                                end: "bottom top",
                                scrub: !0,
                                onEnter: function() {
                                    n(n.CN(".section-fifteen .sticky .btn-back .btn")).css({
                                        borderColor: "#82f8f0"
                                    }), e.restart()
                                },
                                onEnterBack: function() {
                                    n(n.CN(".section-fifteen .sticky .btn-back .btn")).css({
                                        borderColor: "#82f8f0"
                                    }), e.restart()
                                },
                                onLeave: function() {
                                    e.revert(), n(n.CN(".section-fifteen .sticky .btn-back .btn")).css({
                                        borderColor: "transparent"
                                    })
                                },
                                onLeaveBack: function() {
                                    e.revert(), n(n.CN(".section-fifteen .sticky .btn-back .btn")).css({
                                        borderColor: "transparent"
                                    })
                                }
                            }), n(n.CN(".section-fifteen .sticky .btn-back .first")).on("click", (function() {
                                n("".concat(n.CN(".section-ninteen")).concat(n.CN(".mask-back"))).css({
                                    zIndex: "10",
                                    opacity: "1"
                                })
                            })), n(n.CN(".section-ninteen .close")).on("click", (function() {
                                n("".concat(n.CN(".section-ninteen")).concat(n.CN(".mask-back"))).css({
                                    opacity: "0",
                                    zIndex: "-2"
                                })
                            }))
                        }(), u(),
                        function() {
                            var e = !1;

                            function t() {
                                var e = n(n.CN(".section-eighteen .white-box")).position().top,
                                    t = n(n.CN(".section-eighteen .box3")).position().top,
                                    s = a ? 1.3 : 2.3;
                                e < p * s && t > p * s ? (n(n.CN(".section-eighteen .close .img1")).css("opacity", "0"), n(n.CN(".section-eighteen .close .img2")).css("opacity", "1")) : (n(n.CN(".section-eighteen .close .img1")).css("opacity", "1"), n(n.CN(".section-eighteen .close .img2")).css("opacity", "0"))
                            }
                            n(n.CN(".section-eighteen .modal-content .link")).on("click", (function(s) {
                                (e = !e) ? (n(n.CN(".section-eighteen .white-box")).css("display", "block"), n(n.CN(".section-eighteen .modal-content .link svg")).css("transform", "rotate(180deg)"), n(n.CN(".section-eighteen")).on("scroll", t)) : (n(n.CN(".section-eighteen")).off("scroll"), n(n.CN(".section-eighteen .close .img1")).css("opacity", "1"), n(n.CN(".section-eighteen .close .img2")).css("opacity", "0"), n(n.CN(".section-eighteen .white-box")).css("display", "none"), n(n.CN(".section-eighteen .modal-content .link svg")).css("transform", "rotate(0deg)"))
                            }))
                        }(), a ? ((v = new Swiper("".concat(n.CN(".section-third"), " .swiper"), {
                            direction: "horizontal",
                            loop: !0,
                            loopedSlides: 6,
                            slidesPerView: "auto",
                            centeredSlides: !1,
                            autoplay: {
                                duration: 3
                            },
                            spaceBetween: 10,
                            slideActiveClass: "".concat("saros10_", "m-slide-active"),
                            pagination: {
                                el: "".concat(n.CN(".section-third"), " .swiper-pagination"),
                                clickable: !0,
                                bulletClass: n.CN("m-swiper-pagination-bullet"),
                                bulletActiveClass: n.CN("m-swiper-pagination-bullet-active")
                            }
                        })).autoplay.stop(), ScrollTrigger.create({
                            trigger: n("".concat(n.CN(".section-third"), " .swiper")),
                            start: "top center-=10%",
                            end: "bottom center-=10%",
                            scrub: !0,
                            onEnter: function() {
                                v.autoplay.start()
                            },
                            onEnterBack: function() {
                                v.autoplay.start()
                            },
                            onLeave: function() {
                                v.autoplay.stop()
                            },
                            onLeaveBack: function() {
                                v.autoplay.stop()
                            }
                        }), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-fifth .sticky-back")),
                                start: "top top",
                                end: "bottom bottom",
                                scrub: !0
                            }
                        }).to(n.CN(".section-fifth .sticky video"), {
                            width: r - .4 * p,
                            height: (r - .4 * p) / .825,
                            borderRadius: .02 * p
                        }).to(n.CN(".section-fifth .sticky"), {
                            height: 4 * p,
                            top: (c - 4 * p) / 2
                        }, "<"), g(".section-seventh"), d(".section-seventh"), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-seventh .sticky-back")),
                                start: "top top+=".concat(c / 2),
                                end: "bottom bottom",
                                scrub: !0
                            }
                        }).to(n.CN(".section-seventh .sticky video"), {
                            width: "100%",
                            height: "100vh",
                            top: "50%",
                            y: "-50%"
                        }), gsap.timeline({
                            scrollTrigger: {
                                trigger: n(n.CN(".section-seventh > .bottom-block")),
                                start: "top bottom",
                                end: "center bottom",
                                scrub: !0
                            }
                        }).to(n.CN(".section-seventh > .bottom-block"), {
                            y: -1 * n(n.CN(".section-seventh > .bottom-block .left")).innerHeight(),
                            opacity: 1
                        }).to(n.CN(".section-seventh .section-content"), {
                            y: -1 * n(n.CN(".section-seventh > .bottom-block .left")).innerHeight()
                        }, "<"), ScrollTrigger.create({
                            trigger: n(n.CN(".section-seventh > .bottom-block")),
                            start: "center+=25% bottom",
                            end: "center+=25% bottom",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-seventh > .bottom-block .red-line2")).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-seventh > .bottom-block .red-line2")).removeClass(n.CN("active"))
                            }
                        }), g(".section-tenth"), ScrollTrigger.create({
                            trigger: n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line1")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line1")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line1")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line2")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line2")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line2")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line3")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line3")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-tenth .bottom-line".concat(n.CN(".line3")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line1")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line1")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line1")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line2")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line2")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-eleventh .bottom-line".concat(n.CN(".line2")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line1")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line1")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line1")))).removeClass(n.CN("active"))
                            }
                        }), ScrollTrigger.create({
                            trigger: n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line2")))),
                            start: "top bottom-=10%",
                            end: "top bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line2")))).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-twelfth .bottom-line".concat(n.CN(".line2")))).removeClass(n.CN("active"))
                            }
                        }), 
                        // C = new Array(76).fill().map((function(e, t) {
                        //     return "".concat("/cdn/shop/", "files/").concat("saros10_", "vd-mob-").concat(t + 1, ".jpg")
                        // })), h = (0, i.imageSequence)({
                        //     urls: C,
                        //     canvas: "#image-sequence-14",
                        //     clear: !0,
                        //     objectFit: "contain"
                        // }), gsap.timeline({
                        //     yoyo: !0,
                        //     scrollTrigger: {
                        //         trigger: n(n.CN(".section-forteen .sticky-back")),
                        //         start: "top top",
                        //         end: "bottom bottom",
                        //         scrub: !0
                        //     }
                        // }).add(h), 
                        ScrollTrigger.create({
                            trigger: n(n.CN(".section-forteen .sticky-back")),
                            start: "bottom bottom-=10%",
                            end: "bottom bottom-=10%",
                            scrub: !0,
                            onEnter: function() {
                                n(n.CN(".section-forteen .bottom-line")).addClass(n.CN("active"))
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-forteen .bottom-line")).removeClass(n.CN("active"))
                            }
                        }), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-forteen .card-box2 .img-mob")),
                                start: "top bottom",
                                end: "center center",
                                scrub: !0
                            }
                        }).to(n(n.CN(".section-forteen .card-box2 svg")), {
                            y: .3 * p
                        }), n(n.CN(".section-forteen .card-box3")).on("click", (function() {
                            n("".concat(n.CN(".section-eighteen")).concat(n.CN(".mask-back"))).css({
                                zIndex: "10",
                                opacity: "1"
                            })
                        })), 
                        n(n.CN(".section-eighteen .close")).on("click", (function() {
                            n("".concat(n.CN(".section-eighteen")).concat(n.CN(".mask-back"))).css({
                                opacity: "0",
                                zIndex: "-2"
                            })
                        })), new Swiper("".concat(n.CN(".section-ninteen"), " .swiper"), {
                            direction: "horizontal",
                            loop: !0,
                            loopedSlides: 4,
                            slidesPerView: "auto",
                            centeredSlides: !0,
                            autoplay: {
                                duration: 3
                            },
                            spaceBetween: 20,
                            pagination: {
                                el: "".concat(n.CN(".section-ninteen"), " .swiper-pagination"),
                                clickable: !0,
                                bulletClass: n.CN("m-swiper-pagination-bullet"),
                                bulletActiveClass: n.CN("m-swiper-pagination-bullet-active")
                            }
                        })) : (gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-fifth .sticky-back")),
                                start: "top top",
                                end: "bottom bottom",
                                scrub: !0
                            }
                        }).to(n.CN(".section-fifth .sticky video"), {
                            width: 14 * p,
                            height: 7 * p,
                            borderRadius: .05 * p
                        }).to(n.CN(".section-fifth .sticky"), {
                            height: 7 * p,
                            top: (c - 7 * p) / 2
                        }, "<"), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-fifth .card-bottom")),
                                start: "center bottom-=20%",
                                end: "center center",
                                scrub: !0
                            }
                        }).to(n.CN(".section-fifth .card-bottom"), {
                            boxShadow: "0px 0px 50px 0px #5E1A1A"
                        }).to(n.CN(".section-fifth .card-bottom .back"), {
                            opacity: .4
                        }, "<"), console.log(n(n.CN(".section-seventh > .bottom-block")).height()), gsap.timeline({
                            yoyo: !0,
                            scrollTrigger: {
                                trigger: n(n.CN(".section-seventh .sticky-back")),
                                start: "top top+=".concat(c / 2),
                                end: "bottom bottom",
                                scrub: !0
                            }
                        }).to(n.CN(".section-seventh .sticky video"), {
                            width: "100%",
                            height: "100vh",
                            top: "50%",
                            y: "-50%"
                        }), gsap.timeline({
                            scrollTrigger: {
                                trigger: n(n.CN(".section-seventh > .bottom-block")),
                                start: "top bottom",
                                end: "top bottom-=15%",
                                scrub: !0
                            }
                        }).to(n.CN(".section-seventh > .bottom-block"), {
                            y: "-99%",
                            opacity: 1
                        }).to(n.CN(".section-seventh .section-content"), {
                            y: -1 * n(n.CN(".section-seventh > .bottom-block")).innerHeight() + 1
                        }, "<"), g(".section-seventh"), d(".section-seventh"), g(".section-tenth"), d(".section-tenth"), t = !1, s = !1, o = !1, b = n(n.CN(".section-twelfth video:first-child")).get(0), f = n(n.CN(".section-twelfth video:nth-child(2)")).get(0), _ = n(n.CN(".section-twelfth video:nth-child(3)")).get(0), b.addEventListener("loadedmetadata", (function() {
                            t ? b.play() : t = !0
                        })), f.addEventListener("loadedmetadata", (function() {
                            s ? f.play() : s = !0
                        })), _.addEventListener("loadedmetadata", (function() {
                            o ? _.play() : o = !0
                        })), ScrollTrigger.create({
                            trigger: n(n.CN(".section-twelfth .video-back")),
                            start: "top bottom",
                            end: "top bottom",
                            scrub: !0,
                            onEnter: function() {
                                t || (t = !0), b.play(), n(n.CN(".section-twelfth .video-title-back .video-title:first-child")).css({
                                    color: "#fff"
                                }), n(n.CN(".section-twelfth video:first-child")).css({
                                    opacity: 1
                                }), n(n.CN(".section-twelfth .tips .center:first-child")).css({
                                    opacity: 1
                                }), n(n.CN(".section-twelfth .line-back .active-line")).css({
                                    left: 0
                                })
                            },
                            onEnterBack: function() {
                                n(n.CN(".section-twelfth .video-title-back .video-title")).css({
                                    color: "rgba(255, 255, 255, 0.2)"
                                }), n(n.CN(".section-twelfth video")).css({
                                    opacity: 0
                                }), n(n.CN(".section-twelfth .tips .center")).css({
                                    opacity: 0
                                }), n(n.CN(".section-twelfth .line-back .active-line")).css({
                                    left: 0
                                }), b.pause(), f.pause(), _.pause(), b.currentTime = 0, f.currentTime = 0, _.currentTime = 0
                            }
                        }), n(n.CN(".section-twelfth .video-title-back .v1")).on("click", (function() {
                            n(n.CN(".section-twelfth .video-title-back .video-title")).css({
                                color: "rgba(255, 255, 255, 0.2)"
                            }), n(n.CN(".section-twelfth video")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth .tips .center")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth video:first-child")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .tips .center:first-child")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .video-title-back .video-title:first-child")).css({
                                color: "#fff"
                            }), n(n.CN(".section-twelfth .line-back .active-line")).css({
                                left: 0
                            }), s && (f.pause(), f.currentTime = 0), o && (_.pause(), _.currentTime = 0), b.currentTime = 0, b.play(), t || (t = !0)
                        })), n(n.CN(".section-twelfth .video-title-back .v2")).on("click", (function() {
                            n(n.CN(".section-twelfth .video-title-back .video-title")).css({
                                color: "rgba(255, 255, 255, 0.2)"
                            }), n(n.CN(".section-twelfth video")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth .tips .center")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth video:nth-child(2)")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .tips .center:nth-child(2)")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .video-title-back .video-title:nth-child(2)")).css({
                                color: "#fff"
                            }), n(n.CN(".section-twelfth .line-back .active-line")).css({
                                left: "33.33%"
                            }), t && (b.pause(), b.currentTime = 0), o && (_.pause(), _.currentTime = 0), f.currentTime = 0, f.play(), s || (s = !0)
                        })), n(n.CN(".section-twelfth .video-title-back .v3")).on("click", (function() {
                            n(n.CN(".section-twelfth .video-title-back .video-title")).css({
                                color: "rgba(255, 255, 255, 0.2)"
                            }), n(n.CN(".section-twelfth video")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth .tips .center")).css({
                                opacity: 0
                            }), n(n.CN(".section-twelfth video:nth-child(3)")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .tips .center:nth-child(3)")).css({
                                opacity: 1
                            }), n(n.CN(".section-twelfth .video-title-back .video-title:nth-child(3)")).css({
                                color: "#fff"
                            }), n(n.CN(".section-twelfth .line-back .active-line")).css({
                                left: "66.66%"
                            }), t && (b.pause(), b.currentTime = 0), s && (f.pause(), f.currentTime = 0), _.currentTime = 0, _.play(), o || (o = !0)
                        })), function() {
                            // var e = new Array(76).fill().map((function(e, t) {
                            //         return "".concat("/cdn/shop/", "files/").concat("saros10_", "vd-pc-").concat(t + 1, ".jpg")
                            //     })),
                            //     t = (0, i.imageSequence)({
                            //         urls: e,
                            //         canvas: "#image-sequence-14",
                            //         clear: !0,
                            //         objectFit: "contain"
                            //     });
                            // gsap.timeline({
                            //     yoyo: !0,
                            //     scrollTrigger: {
                            //         trigger: n(n.CN(".section-forteen .sticky-back")),
                            //         start: "top top",
                            //         end: "bottom bottom",
                            //         scrub: !0
                            //     }
                            // }).add(t), 
                            ScrollTrigger.create({
                                trigger: n(n.CN(".section-forteen .sticky-back")),
                                start: "bottom bottom-=10%",
                                end: "bottom bottom-=10%",
                                scrub: !0,
                                onEnter: function() {
                                    n(n.CN(".section-forteen .bottom-line")).addClass(n.CN("active"))
                                },
                                onEnterBack: function() {
                                    n(n.CN(".section-forteen .bottom-line")).removeClass(n.CN("active"))
                                }
                            }), gsap.timeline({
                                yoyo: !0,
                                scrollTrigger: {
                                    trigger: n(n.CN(".section-forteen .line-box")),
                                    start: "bottom bottom",
                                    end: "center center",
                                    scrub: !0
                                }
                            }).to(n(n.CN(".section-forteen .line-box")), {
                                width: "100%",
                                duration: 1
                            }).to(n(n.CN(".section-forteen .temperature-box .num1")), {
                                opacity: 1,
                                duration: .2
                            }, "<").to(n(n.CN(".section-forteen .temperature-box .num2")), {
                                opacity: 1,
                                duration: .2
                            }, "-=0.8").to(n(n.CN(".section-forteen .temperature-box .num3")), {
                                opacity: 1,
                                duration: .2
                            }, "-=0.5").to(n(n.CN(".section-forteen .tip")), {
                                opacity: 1
                            }, ">"), gsap.timeline({
                                yoyo: !0,
                                scrollTrigger: {
                                    trigger: n(n.CN(".section-forteen .card-box2")),
                                    start: "top bottom-=30%",
                                    end: "center center-=30%",
                                    scrub: !0
                                }
                            }).to(n(n.CN(".section-forteen .card-box2 svg")), {
                                y: .5 * p
                            }), n(n.CN(".section-forteen .card-box3")).on("click", (function() {
                                n("".concat(n.CN(".section-eighteen")).concat(n.CN(".mask-back"))).css({
                                    zIndex: "10",
                                    opacity: "1"
                                })
                            })), n(n.CN(".section-eighteen .close")).on("click", (function() {
                                n("".concat(n.CN(".section-eighteen")).concat(n.CN(".mask-back"))).css({
                                    opacity: "0",
                                    zIndex: "-2"
                                })
                            }))
                        }())
                })), window.onload = function() {}
            },
            "./src/widgets/Album/index.js": function(e, t, s) {
                "use strict";

                function i() {
                    document.documentElement.clientWidth || window.innerWidth;
                    new Swiper("#qSwiperAlbum", {
                        grabCursor: !0,
                        speed: 2e4,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    }), new Swiper("#qSwiperAlbum-1", {
                        grabCursor: !0,
                        speed: 16e3,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    })
                }
                s.d(t, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(e, t, s) {
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            return e.startsWith(".") ? e.split(" ").map((function(e) {
                                return e.startsWith(".") ? ".".concat("saros10_").concat(e.slice(1)) : e
                            })).join(" ") : "saros10_" + e
                        }
                    })
                }(s("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(e, t, s) {
                "use strict";
                var i = s("jquery");

                function o(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, t) {
                        var s = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != s) {
                            var i, o, n, c, r = [],
                                a = !0,
                                p = !1;
                            try {
                                if (n = (s = s.call(e)).next, 0 === t) {
                                    if (Object(s) !== s) return;
                                    a = !1
                                } else
                                    for (; !(a = (i = n.call(s)).done) && (r.push(i.value), r.length !== t); a = !0);
                            } catch (e) {
                                p = !0, o = e
                            } finally {
                                try {
                                    if (!a && null != s.return && (c = s.return(), Object(c) !== c)) return
                                } finally {
                                    if (p) throw o
                                }
                            }
                            return r
                        }
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return n(e, t);
                        var s = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === s && e.constructor && (s = e.constructor.name);
                        if ("Map" === s || "Set" === s) return Array.from(e);
                        if ("Arguments" === s || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)) return n(e, t)
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function n(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var s = 0, i = new Array(t); s < t; s++) i[s] = e[s];
                    return i
                }
                i((function() {
                    var e = document.documentElement.clientWidth || window.innerWidth;
                    ! function() {
                        var t, s, n = JSON.parse((null === (t = document.getElementById("compare_data")) || void 0 === t ? void 0 : t.text) || "{}"),
                            c = (s = n, JSON.parse(JSON.stringify(s)));

                        function r(t) {
                            var s = "";
                            Object.entries(t).forEach((function(t, i) {
                                var c = o(t, 2),
                                    r = c[0],
                                    a = c[1];
                                i > (e > 750 ? 2 : 1) || (s += '<div class="'.concat("saros10_", 'item">\n          <img src="').concat(a.imgsrc, '" alt="').concat(a.name, '">\n          <div class="').concat("saros10_", 'h4">').concat(a.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("saros10_", 'popup">\n              <div class="').concat("saros10_", 'models">').concat(a.choose, "</div>"), Object.entries(n).forEach((function(e) {
                                    var t = o(e, 2),
                                        i = t[0],
                                        n = t[1];
                                    s += '<p class="'.concat("saros10_", 'modlist" parentlevel="').concat(r, '" productname="').concat(i, '">\n                <svg class="').concat(a.name == n.name ? "".concat("saros10_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(n.name, "</span></p>")
                                })), s += "</div>\n          </div>\n          <div>", a.open_purchase ? s += '<button class="'.concat("saros10_", 'buy-now purchase-sales-channel-btn" product-name="').concat(a.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(a.btntext, "</button>") : a.show_link_btn ? s += '<a href="'.concat(a.btn_link, '"><button class="').concat("saros10_", 'buy-now">').concat(a.btntext, "</button></a>") : s += '<div class="'.concat("saros10_", 'no_btn"></div>'), s += "</div>\n          <ul>", Object.entries(a).forEach((function(e) {
                                    var t = o(e, 2),
                                        i = t[0],
                                        n = t[1];
                                    i.includes("item") && (s += "<li>".concat(n, "</li>"))
                                })), s += "</ul>\n        </div>")
                            })), i("#compare-table").html(s), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                        }
                        r(n), i(i.CN(".contrast-container")).on("click", i.CN(".h4"), (function() {
                            i(this).children(i.CN(".popup")).toggle()
                        })), i(document).on("click", (function(e) {
                            i(e.target).closest(i.CN(".contrast-container .h4")).length || i(i.CN(".contrast-container .popup")).hide()
                        })), i(i.CN(".contrast-container")).on("click", i.CN(".h4 .modlist"), (function(e) {
                            var t = i(this).attr("productname"),
                                s = i(this).attr("parentlevel");
                            c[s] = n[t], r(c)
                        }))
                    }()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(e, t, s) {
                "use strict";
                var i = s("jquery");
                i((function() {
                    function e() {
                        i(i.CN(".full_screen_video")).hide();
                        var e = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(e)
                    }! function() {
                        var e = document.querySelectorAll(i.CN(".as-youtube-video"));
                        if (e.length > 0) {
                            var t = document.createElement("script");
                            t.src = "https://www.youtube.com/iframe_api";
                            var s = document.getElementsByTagName("script")[0];
                            s.parentNode.insertBefore(t, s);
                            var o = [],
                                n = function(e) {
                                    document.addEventListener("hide.all.modals", (function(e) {
                                        for (var t = 0; t < o.length; t++) o[t].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var t = 0; t < e.length; t++) o.push(new window.YT.Player(e[t], {
                                    events: {
                                        onReady: n
                                    }
                                }))
                            }
                        }
                    }(), i(i.CN(".section-first .text-area .videoBtn")).on("click", (function(e) {
                        console.log("videoBtn"), i(i.CN(".full_screen_video")).show()
                    })), i(i.CN(".full_screen_video")).on("click", (function(t) {
                        e()
                    })), i(i.CN(".full_screen_video .video-close")).on("click", (function(t) {
                        e()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(e, t, s) {
                "use strict";
                s("jquery")
            },
            "./src/widgets/SeriseContainer/index.js": function(e, t, s) {
                "use strict";
                var i = s("jquery");
                i((function() {
                    i("#sideBtn").on("click", (function() {
                        var e = i(i.CN(".serise-container"));
                        e.hasClass(i.CN("show")) ? e.addClass(i.CN("hide")).removeClass(i.CN("show")) : e.addClass(i.CN("show")).removeClass(i.CN("hide"))
                    })), i("#popup-tab").delegate(i.CN(".tabTitle"), "click", (function(e) {
                        i(this).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".tabbody .tabCard")).eq(i(this).index()).show().siblings().hide(), i(i.CN(".pc .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".mob .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(e, t, s) {
                "use strict";
                s.d(t, {
                    basics: function() {
                        return o
                    }
                });
                var i = s("jquery");

                function o() {
                    i(".ad-bar").length > 0 && i(i.CN(".container")).css({
                        "margin-top": "110px"
                    }), i("#product_subscription_b").on("click", (function() {
                        i("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(e, t, s) {
                "use strict";
                s.d(t, {
                    debugfunction: function() {
                        return o
                    }
                });
                var i = s("jquery");

                function o() {
                    var e, t, s, o, n, c, r, a, p = null,
                        l = !1,
                        g = null,
                        d = null,
                        m = null,
                        u = null;

                    function b() {
                        var e = window.innerWidth,
                            t = window.innerHeight;
                        window.outerWidth, window.outerHeight;
                        p && (p.text("分辨率".concat(e, "*").concat(t)), window.innerWidth > 751 ? (i(g).css("display", "block"), i(d).css("display", "block"), i(m).css("display", "block"), i(u).css("display", "block")) : (i(g).css("display", "none"), i(d).css("display", "none"), i(m).css("display", "none"), i(u).css("display", "none")))
                    }
                    // e = window.location.href, t = new URL(e), s = t.hostname, o = t.searchParams.get("debugResolution"), !(n = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(s) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(s) && "show" != o || (l || function() {
                    //     (p = i("<div>", {
                    //         id: "resolution-container",
                    //         style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //         text: "分辨率: 加载中..."
                    //     })).appendTo("body"), l = !0, g = i("<div>", {
                    //         id: "resolution-choose-Title",
                    //         style: "position:fixed;top:10px;left:263px;z-index:9999999;color:#000;padding:5px 10px;",
                    //         text: " 分辨率大小按钮=>"
                    //     }), d = i("<a>", {
                    //         id: "resolution-choose1",
                    //         style: "position:fixed;top:10px;left:405px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1920*960"
                    //     }), m = i("<a>", {
                    //         id: "resolution-choose2",
                    //         style: "position:fixed;top:10px;left:500px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1536*754"
                    //     }), u = i("<a>", {
                    //         id: "resolution-choose3",
                    //         style: "position:fixed;top:10px;left:592px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1280*600"
                    //     }), g.appendTo("body"), d.appendTo("body"), m.appendTo("body"), u.appendTo("body");
                    //     var e = window.location.href;
                    //     d.on("click", (function() {
                    //         window.open(e, "_blank", "width=1920,height=961")
                    //     })), m.on("click", (function() {
                    //         window.open(e, "_blank", "width=1536,height=755")
                    //     })), u.on("click", (function() {
                    //         window.open(e, "_blank", "width=1280,height=601")
                    //     }))
                    // }(), b(), n.test(s)), i(window).resize((c = b, r = 200, a = 0, function() {
                    //     var e = (new Date).getTime();
                    //     e - a >= r && (a = e, c.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/gsap-sequence.js": function(e, t, s) {
                "use strict";
                s.d(t, {
                    imageSequence: function() {
                        return o
                    }
                });
                var i = s("jquery");

                function o(e) {
                    n(i(e.canvas));
                    var t, s = {
                            frame: 0
                        },
                        o = gsap.utils.toArray(e.canvas)[0] || console.warn("canvas not defined"),
                        c = o.getContext("2d"),
                        r = -1,
                        a = e.onUpdate,
                        p = function() {
                            var i = Math.round(s.frame);
                            if (i !== r) {
                                e.clear && c.clearRect(0, 0, o.width, o.height);
                                var n, p, l, g, d = t[Math.round(s.frame)],
                                    m = d.width / d.height,
                                    u = o.width / o.height;
                                "contain" === e.objectFit ? (m <= u ? (l = m * o.height, g = o.height, n = (o.width - l) / 2, p = 0) : (g = (l = o.width) / m, n = 0, p = (o.height - g) / 2), c.drawImage(d, 0, 0, d.width, d.height, n, p, l, g)) : (m <= u ? (l = d.width, g = d.width / u, n = 0, p = (d.height - g) / 2) : (l = d.height * u, g = d.height, n = (d.width - l) / 2, p = 0), c.drawImage(d, n, p, l, g, 0, 0, o.width, o.height)), r = i, a && a.call(this, i, t[i])
                            }
                        };
                    return window.addEventListener("resize", function(e, t) {
                        var s = null,
                            i = null,
                            o = null;

                        function n() {
                            (o = +new Date) - s < t ? i = setTimeout(n, t) : (e(), i = null), s = o
                        }
                        return function() {
                            s = +new Date, i || (i = setTimeout(n, t))
                        }
                    }((function() {
                        n(i(e.canvas))
                    }), 300), !1), t = e.urls.map((function(e, t) {
                        var s = new Image;
                        return s.src = e, t || (s.onload = p), s
                    })), gsap.to(s, {
                        frame: t.length - 1,
                        ease: "none",
                        onUpdate: p,
                        duration: t.length / (e.fps || 30),
                        paused: !!e.paused,
                        scrollTrigger: e.scrollTrigger,
                        onComplete: e.onComplete,
                        onReverseComplete: e.onReverseComplete
                    })
                }

                function n(e) {
                    var t = e.innerWidth(),
                        s = e.innerHeight(),
                        i = window.devicePixelRatio;
                    e.attr("width", Math.round(t * i)), e.attr("height", Math.round(s * i))
                }
            },
            "./src/widgets/index.js": function(e, t, s) {
                "use strict";
                s("./src/widgets/ContrastContainer/index.js"), s("./src/widgets/FullScreenVideo/index.js"), s("./src/widgets/LeftNav/index.js"), s("./src/widgets/SeriseContainer/index.js"), s("./src/widgets/ClassExtension.js");
                var i = s("./src/widgets/Album/index.js"),
                    o = s("./src/widgets/basics.js");
                (0, i.default)(), (0, o.basics)()
            },
            "./src/index.html": function(e, t, s) {
                "use strict";
                var i = s("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    o = s.n(i),
                    n = new URL(s("./src/assets/images/section0-back.jpg"), s.b),
                    c = new URL(s("./src/assets/video/section1.mp4"), s.b),
                    r = new URL(s("./src/assets/video/section1-mob.mp4"), s.b),
                    a = new URL(s("./src/assets/images/section1-back.jpg"), s.b),
                    p = new URL(s("./src/assets/images/section1-back-mob.jpg"), s.b),
                    l = new URL(s("./src/assets/images/section2-icon1.png"), s.b),
                    g = new URL(s("./src/assets/images/section2-icon2.png"), s.b),
                    d = new URL(s("./src/assets/images/reward_da_2025.png"), s.b),
                    m = new URL(s("./src/assets/images/reward_tuv.png"), s.b),
                    u = new URL(s("./src/assets/images/reward_scva.png"), s.b),
                    b = new URL(s("./src/assets/images/video-icon.png"), s.b),
                    f = new URL(s("./src/assets/images/section3-1.jpg"), s.b),
                    _ = new URL(s("./src/assets/images/section3-2.jpg"), s.b),
                    C = new URL(s("./src/assets/images/section3-3.jpg"), s.b),
                    h = new URL(s("./src/assets/images/section3-4.jpg"), s.b),
                    v = new URL(s("./src/assets/images/section3-5.jpg"), s.b),
                    w = new URL(s("./src/assets/images/section3-6.jpg"), s.b),
                    N = new URL(s("./src/assets/images/section3-1-mob.jpg"), s.b),
                    x = new URL(s("./src/assets/images/section3-2-mob.jpg"), s.b),
                    j = new URL(s("./src/assets/images/section3-3-mob.jpg"), s.b),
                    y = new URL(s("./src/assets/images/section3-4-mob.jpg"), s.b),
                    S = new URL(s("./src/assets/images/section3-5-mob.jpg"), s.b),
                    k = new URL(s("./src/assets/images/section3-6-mob.jpg"), s.b),
                    L = new URL(s("./src/assets/images/2options.jpg"), s.b),
                    V = new URL(s("./src/assets/video/section5.mp4"), s.b),
                    R = new URL(s("./src/assets/video/section5-mob.mp4"), s.b),
                    U = new URL(s("./src/assets/images/section5-bottom-back.png"), s.b),
                    E = new URL(s("./src/assets/images/section5.jpg"), s.b),
                    T = new URL(s("./src/assets/video/section6-1.mp4"), s.b),
                    B = new URL(s("./src/assets/video/section6-1-mob.mp4"), s.b),
                    z = new URL(s("./src/assets/video/section6-2.mp4"), s.b),
                    A = new URL(s("./src/assets/video/section6-2-mob.mp4"), s.b),
                    I = new URL(s("./src/assets/video/section6-3.mp4"), s.b),
                    q = new URL(s("./src/assets/video/section6-3-mob.mp4"), s.b),
                    O = new URL(s("./src/assets/video/section7.mp4"), s.b),
                    P = new URL(s("./src/assets/video/section7-mob.mp4"), s.b),
                    M = new URL(s("./src/assets/images/section7-1.jpg"), s.b),
                    W = new URL(s("./src/assets/images/section7-2.jpg"), s.b),
                    F = new URL(s("./src/assets/video/section8-1.mp4"), s.b),
                    H = new URL(s("./src/assets/video/section8-1-mob.mp4"), s.b),
                    Q = new URL(s("./src/assets/images/section8-1.png"), s.b),
                    D = new URL(s("./src/assets/images/section8-1-mob.png"), s.b),
                    $ = new URL(s("./src/assets/video/section8-2.mp4"), s.b),
                    J = new URL(s("./src/assets/video/section8-2-mob.mp4"), s.b),
                    Y = new URL(s("./src/assets/images/section8-2.png"), s.b),
                    G = new URL(s("./src/assets/images/section8-2-mob.png"), s.b),
                    K = new URL(s("./src/assets/video/section10.mp4"), s.b),
                    X = new URL(s("./src/assets/video/section10-mob.mp4"), s.b),
                    Z = new URL(s("./src/assets/images/section10-1.jpg"), s.b),
                    ee = new URL(s("./src/assets/images/section10-1-mob.jpg"), s.b),
                    te = new URL(s("./src/assets/images/section10-2.jpg"), s.b),
                    se = new URL(s("./src/assets/images/section10-2-mob.jpg"), s.b),
                    ie = new URL(s("./src/assets/video/section11.mp4"), s.b),
                    oe = new URL(s("./src/assets/video/section11-mob.mp4"), s.b),
                    ne = new URL(s("./src/assets/images/section11.png"), s.b),
                    ce = new URL(s("./src/assets/images/section11-mob.png"), s.b),
                    re = new URL(s("./src/assets/video/section12-1.mp4"), s.b),
                    ae = new URL(s("./src/assets/video/section12-2.mp4"), s.b),
                    pe = new URL(s("./src/assets/video/section12-3.mp4"), s.b),
                    le = new URL(s("./src/assets/video/section12-1-mob.mp4"), s.b),
                    ge = new URL(s("./src/assets/video/section12-2-mob.mp4"), s.b),
                    de = new URL(s("./src/assets/video/section12-3-mob.mp4"), s.b),
                    me = new URL(s("./src/assets/video/section13-1.mp4"), s.b),
                    ue = new URL(s("./src/assets/video/section13-1-mob.mp4"), s.b),
                    be = new URL(s("./src/assets/video/section13-2.mp4"), s.b),
                    fe = new URL(s("./src/assets/video/section13-2-mob.mp4"), s.b),
                    _e = new URL(s("./src/assets/images/section14-icon1.png"), s.b),
                    Ce = new URL(s("./src/assets/images/section14-icon2.png"), s.b),
                    he = new URL(s("./src/assets/images/section14-icon3.png"), s.b),
                    ve = new URL(s("./src/assets/images/section14-icon4.png"), s.b),
                    we = new URL(s("./src/assets/images/section14-icon5.png"), s.b),
                    Ne = new URL(s("./src/assets/images/section14-icon6.png"), s.b),
                    xe = new URL(s("./src/assets/images/section14-icon7.png"), s.b),
                    je = new URL(s("./src/assets/images/section14-icon8.png"), s.b),
                    ye = new URL(s("./src/assets/images/section14-icon9.png"), s.b),
                    Se = new URL(s("./src/assets/images/section14-card1-left.png"), s.b),
                    ke = new URL(s("./src/assets/images/section14-card1-left-mob.png"), s.b),
                    Le = new URL(s("./src/assets/images/section14-card1-right.jpg"), s.b),
                    Ve = new URL(s("./src/assets/images/section14-card1-right-mob.jpg"), s.b),
                    Re = new URL(s("./src/assets/images/section14-card2-back.jpg"), s.b),
                    Ue = new URL(s("./src/assets/images/section14-card2.png"), s.b),
                    Ee = new URL(s("./src/assets/images/section14-card2-back-mob.jpg"), s.b),
                    Te = new URL(s("./src/assets/images/section14-card2-mob.png"), s.b),
                    Be = new URL(s("./src/assets/images/section14-card3.png"), s.b),
                    ze = new URL(s("./src/assets/images/section15.jpg"), s.b),
                    Ae = new URL(s("./src/assets/images/section15-mob.jpg"), s.b),
                    Ie = new URL(s("./src/assets/images/section15-bg.png"), s.b),
                    qe = new URL(s("./src/assets/images/section15-bg-mob.png"), s.b),
                    Oe = new URL(s("./src/assets/images/section15-home-icon.png"), s.b),
                    Pe = new URL(s("./src/assets/images/section15-app.png"), s.b),
                    Me = new URL(s("./src/assets/images/section15-app-mob.png"), s.b),
                    We = new URL(s("./src/assets/images/section15-plan.jpg"), s.b),
                    Fe = new URL(s("./src/assets/images/section15-plan-mob.jpg"), s.b),
                    He = new URL(s("./src/assets/images/section16.jpg"), s.b),
                    Qe = new URL(s("./src/assets/images/section16-mob.jpg"), s.b),
                    De = new URL(s("./src/assets/images/section16-card1.jpg"), s.b),
                    $e = new URL(s("./src/assets/images/section16-card2.jpg"), s.b),
                    Je = new URL(s("./src/assets/images/section16-card3.jpg"), s.b),
                    Ye = new URL(s("./src/assets/images/section16-card4.jpg"), s.b),
                    Ge = new URL(s("./src/assets/images/section16-card1-mob.jpg"), s.b),
                    Ke = new URL(s("./src/assets/images/section16-card2-mob.jpg"), s.b),
                    Xe = new URL(s("./src/assets/images/section16-card3-mob.jpg"), s.b),
                    Ze = new URL(s("./src/assets/images/section16-card4-mob.jpg"), s.b),
                    et = new URL(s("./src/assets/images/section16-bottom-back-add-scvd.png"), s.b),
                    tt = new URL(s("./src/assets/images/section16-bottom-back-add-scvd-mob.png"), s.b),
                    st = new URL(s("./src/assets/images/close1.png"), s.b),
                    it = new URL(s("./src/assets/images/section17-icon1.png"), s.b),
                    ot = new URL(s("./src/assets/images/section17-1.jpg"), s.b),
                    nt = new URL(s("./src/assets/images/section17-icon2.png"), s.b),
                    ct = new URL(s("./src/assets/images/section17-2.jpg"), s.b),
                    rt = new URL(s("./src/assets/images/section17-icon3.png"), s.b),
                    at = new URL(s("./src/assets/images/section17-3.jpg"), s.b),
                    pt = new URL(s("./src/assets/images/section17-icon4.png"), s.b),
                    lt = new URL(s("./src/assets/images/section17-4.jpg"), s.b),
                    gt = new URL(s("./src/assets/images/section17-bottom.png"), s.b),
                    dt = new URL(s("./src/assets/images/section17-bottom-mob.png"), s.b),
                    mt = new URL(s("./src/assets/images/close.png"), s.b),
                    ut = new URL(s("./src/assets/images/section18-1.jpg"), s.b),
                    bt = new URL(s("./src/assets/images/section18-1-mob.jpg"), s.b),
                    ft = new URL(s("./src/assets/images/section18-3.jpg"), s.b),
                    _t = new URL(s("./src/assets/images/section18-3-mob.jpg"), s.b),
                    Ct = new URL(s("./src/assets/images/section18-2.jpg"), s.b),
                    ht = new URL(s("./src/assets/images/section18-2-mob.jpg"), s.b),
                    vt = new URL(s("./src/assets/images/section19-icon.png"), s.b),
                    wt = new URL(s("./src/assets/images/section19-1.png"), s.b),
                    Nt = new URL(s("./src/assets/images/section19-list1.jpg"), s.b),
                    xt = new URL(s("./src/assets/images/section19-list2.jpg"), s.b),
                    jt = new URL(s("./src/assets/images/section19-list3.jpg"), s.b),
                    yt = new URL(s("./src/assets/images/section19-list4.jpg"), s.b),
                    St = new URL(s("./src/assets/images/section19-2.png"), s.b),
                    kt = new URL(s("./src/assets/images/dimension1.jpg"), s.b),
                    Lt = new URL(s("./src/assets/images/dimension2.jpg"), s.b),
                    Vt = new URL(s("./src/assets/images/1.jpg"), s.b),
                    Rt = new URL(s("./src/assets/images/2.jpg"), s.b),
                    Ut = new URL(s("./src/assets/images/3.jpg"), s.b),
                    Et = new URL(s("./src/assets/images/4.jpg"), s.b),
                    Tt = new URL(s("./src/assets/images/5.jpg"), s.b),
                    Bt = new URL(s("./src/assets/images/6.jpg"), s.b),
                    zt = new URL(s("./src/assets/images/7.jpg"), s.b),
                    At = new URL(s("./src/assets/images/8.jpg"), s.b),
                    It = new URL(s("./src/assets/images/9.jpg"), s.b),
                    qt = new URL(s("./src/assets/images/10.jpg"), s.b),
                    Ot = new URL(s("./src/assets/images/11.jpg"), s.b),
                    Pt = new URL(s("./src/assets/images/12.jpg"), s.b),
                    Mt = new URL(s("./src/assets/images/Saros_10.png"), s.b),
                    Wt = new URL(s("./src/assets/images/Saros_10R.png"), s.b),
                    Ft = o()(n),
                    Ht = o()(c),
                    Qt = o()(r),
                    Dt = o()(a),
                    $t = o()(p),
                    Jt = o()(l),
                    Yt = o()(g),
                    Gt = o()(d),
                    Kt = o()(m),
                    Xt = o()(u),
                    Zt = o()(b),
                    es = o()(f),
                    ts = o()(_),
                    ss = o()(C),
                    is = o()(h),
                    os = o()(v),
                    ns = o()(w),
                    cs = o()(N),
                    rs = o()(x),
                    as = o()(j),
                    ps = o()(y),
                    ls = o()(S),
                    gs = o()(k),
                    ds = o()(L),
                    ms = o()(V),
                    us = o()(R),
                    bs = o()(U),
                    fs = o()(E),
                    _s = o()(T),
                    Cs = o()(B),
                    hs = o()(z),
                    vs = o()(A),
                    ws = o()(I),
                    Ns = o()(q),
                    xs = o()(O),
                    js = o()(P),
                    ys = o()(M),
                    Ss = o()(W),
                    ks = o()(F),
                    Ls = o()(H),
                    Vs = o()(Q),
                    Rs = o()(D),
                    Us = o()($),
                    Es = o()(J),
                    Ts = o()(Y),
                    Bs = o()(G),
                    zs = o()(K),
                    As = o()(X),
                    Is = o()(Z),
                    qs = o()(ee),
                    Os = o()(te),
                    Ps = o()(se),
                    Ms = o()(ie),
                    Ws = o()(oe),
                    Fs = o()(ne),
                    Hs = o()(ce),
                    Qs = o()(re),
                    Ds = o()(ae),
                    $s = o()(pe),
                    Js = o()(le),
                    Ys = o()(ge),
                    Gs = o()(de),
                    Ks = o()(me),
                    Xs = o()(ue),
                    Zs = o()(be),
                    ei = o()(fe),
                    ti = o()(_e),
                    si = o()(Ce),
                    ii = o()(he),
                    oi = o()(ve),
                    ni = o()(we),
                    ci = o()(Ne),
                    ri = o()(xe),
                    ai = o()(je),
                    pi = o()(ye),
                    li = o()(Se),
                    gi = o()(ke),
                    di = o()(Le),
                    mi = o()(Ve),
                    ui = o()(Re),
                    bi = o()(Ue),
                    fi = o()(Ee),
                    _i = o()(Te),
                    Ci = o()(Be),
                    hi = o()(ze),
                    vi = o()(Ae),
                    wi = o()(Ie),
                    Ni = o()(qe),
                    xi = o()(Oe),
                    ji = o()(Pe),
                    yi = o()(Me),
                    Si = o()(We),
                    ki = o()(Fe),
                    Li = o()(He),
                    Vi = o()(Qe),
                    Ri = o()(De),
                    Ui = o()($e),
                    Ei = o()(Je),
                    Ti = o()(Ye),
                    Bi = o()(Ge),
                    zi = o()(Ke),
                    Ai = o()(Xe),
                    Ii = o()(Ze),
                    qi = o()(et),
                    Oi = o()(tt),
                    Pi = o()(st),
                    Mi = o()(it),
                    Wi = o()(ot),
                    Fi = o()(nt),
                    Hi = o()(ct),
                    Qi = o()(rt),
                    Di = o()(at),
                    $i = o()(pt),
                    Ji = o()(lt),
                    Yi = o()(gt),
                    Gi = o()(dt),
                    Ki = o()(mt),
                    Xi = o()(ut),
                    Zi = o()(bt),
                    eo = o()(ft),
                    to = o()(_t),
                    so = o()(Ct),
                    io = o()(ht),
                    oo = o()(vt),
                    no = o()(wt),
                    co = o()(Nt),
                    ro = o()(xt),
                    ao = o()(jt),
                    po = o()(yt),
                    lo = o()(St),
                    go = o()(kt),
                    mo = o()(Lt),
                    uo = o()(Vt),
                    bo = o()(Rt),
                    fo = o()(Ut),
                    _o = o()(Et),
                    Co = o()(Tt),
                    ho = o()(Bt),
                    vo = o()(zt),
                    wo = o()(At),
                    No = o()(It),
                    xo = o()(qt),
                    jo = o()(Ot),
                    yo = o()(Pt);
                o()(Mt), o()(Wt)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(e) {
                "use strict";
                e.exports = function(e, t) {
                    return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), t.hash && (e += t.hash), t.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
                }
            },
            "./src/assets/images/1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_1.jpg"
            },
            "./src/assets/images/10.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_10.jpg"
            },
            "./src/assets/images/11.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_11.jpg"
            },
            "./src/assets/images/12.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_12.jpg"
            },
            "./src/assets/images/2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_2.jpg"
            },
            "./src/assets/images/2options.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_2options.jpg"
            },
            "./src/assets/images/3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_3.jpg"
            },
            "./src/assets/images/4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_4.jpg"
            },
            "./src/assets/images/5.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_5.jpg"
            },
            "./src/assets/images/6.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_6.jpg"
            },
            "./src/assets/images/7.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_7.jpg"
            },
            "./src/assets/images/8.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_8.jpg"
            },
            "./src/assets/images/9.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_9.jpg"
            },
            "./src/assets/images/Saros_10.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_Saros_10.png"
            },
            "./src/assets/images/Saros_10R.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_Saros_10R.png"
            },
            "./src/assets/images/close.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_close.png"
            },
            "./src/assets/images/close1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_close1.png"
            },
            "./src/assets/images/dimension1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_dimension1.jpg"
            },
            "./src/assets/images/dimension2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_dimension2.jpg"
            },
            "./src/assets/images/reward_da_2025.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_reward_da_2025.png"
            },
            "./src/assets/images/reward_scva.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_reward_scva.png"
            },
            "./src/assets/images/reward_tuv.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_reward_tuv.png"
            },
            "./src/assets/images/section0-back.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section0-back.jpg"
            },
            "./src/assets/images/section1-back-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section1-back-mob.jpg"
            },
            "./src/assets/images/section1-back.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section1-back.jpg"
            },
            "./src/assets/images/section10-1-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10-1-mob.jpg"
            },
            "./src/assets/images/section10-1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10-1.jpg"
            },
            "./src/assets/images/section10-2-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10-2-mob.jpg"
            },
            "./src/assets/images/section10-2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10-2.jpg"
            },
            "./src/assets/images/section11-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section11-mob.png"
            },
            "./src/assets/images/section11.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section11.png"
            },
            "./src/assets/images/section14-card1-left-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card1-left-mob.png"
            },
            "./src/assets/images/section14-card1-left.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card1-left.png"
            },
            "./src/assets/images/section14-card1-right-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card1-right-mob.jpg"
            },
            "./src/assets/images/section14-card1-right.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card1-right.jpg"
            },
            "./src/assets/images/section14-card2-back-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card2-back-mob.jpg"
            },
            "./src/assets/images/section14-card2-back.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card2-back.jpg"
            },
            "./src/assets/images/section14-card2-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card2-mob.png"
            },
            "./src/assets/images/section14-card2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card2.png"
            },
            "./src/assets/images/section14-card3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-card3.png"
            },
            "./src/assets/images/section14-icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon1.png"
            },
            "./src/assets/images/section14-icon2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon2.png"
            },
            "./src/assets/images/section14-icon3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon3.png"
            },
            "./src/assets/images/section14-icon4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon4.png"
            },
            "./src/assets/images/section14-icon5.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon5.png"
            },
            "./src/assets/images/section14-icon6.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon6.png"
            },
            "./src/assets/images/section14-icon7.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon7.png"
            },
            "./src/assets/images/section14-icon8.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon8.png"
            },
            "./src/assets/images/section14-icon9.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section14-icon9.png"
            },
            "./src/assets/images/section15-app-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-app-mob.png"
            },
            "./src/assets/images/section15-app.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-app.png"
            },
            "./src/assets/images/section15-bg-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-bg-mob.png"
            },
            "./src/assets/images/section15-bg.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-bg.png"
            },
            "./src/assets/images/section15-home-icon.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-home-icon.png"
            },
            "./src/assets/images/section15-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-mob.jpg"
            },
            "./src/assets/images/section15-plan-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-plan-mob.jpg"
            },
            "./src/assets/images/section15-plan.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15-plan.jpg"
            },
            "./src/assets/images/section15.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section15.jpg"
            },
            "./src/assets/images/section16-bottom-back-add-scvd-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-bottom-back-add-scvd-mob.png"
            },
            "./src/assets/images/section16-bottom-back-add-scvd.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-bottom-back-add-scvd.png"
            },
            "./src/assets/images/section16-card1-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card1-mob.jpg"
            },
            "./src/assets/images/section16-card1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card1.jpg"
            },
            "./src/assets/images/section16-card2-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card2-mob.jpg"
            },
            "./src/assets/images/section16-card2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card2.jpg"
            },
            "./src/assets/images/section16-card3-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card3-mob.jpg"
            },
            "./src/assets/images/section16-card3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card3.jpg"
            },
            "./src/assets/images/section16-card4-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card4-mob.jpg"
            },
            "./src/assets/images/section16-card4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-card4.jpg"
            },
            "./src/assets/images/section16-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16-mob.jpg"
            },
            "./src/assets/images/section16.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section16.jpg"
            },
            "./src/assets/images/section17-1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-1.jpg"
            },
            "./src/assets/images/section17-2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-2.jpg"
            },
            "./src/assets/images/section17-3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-3.jpg"
            },
            "./src/assets/images/section17-4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-4.jpg"
            },
            "./src/assets/images/section17-bottom-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-bottom-mob.png"
            },
            "./src/assets/images/section17-bottom.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-bottom.png"
            },
            "./src/assets/images/section17-icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-icon1.png"
            },
            "./src/assets/images/section17-icon2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-icon2.png"
            },
            "./src/assets/images/section17-icon3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-icon3.png"
            },
            "./src/assets/images/section17-icon4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section17-icon4.png"
            },
            "./src/assets/images/section18-1-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-1-mob.jpg"
            },
            "./src/assets/images/section18-1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-1.jpg"
            },
            "./src/assets/images/section18-2-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-2-mob.jpg"
            },
            "./src/assets/images/section18-2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-2.jpg"
            },
            "./src/assets/images/section18-3-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-3-mob.jpg"
            },
            "./src/assets/images/section18-3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section18-3.jpg"
            },
            "./src/assets/images/section19-1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-1.png"
            },
            "./src/assets/images/section19-2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-2.png"
            },
            "./src/assets/images/section19-icon.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-icon.png"
            },
            "./src/assets/images/section19-list1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-list1.jpg"
            },
            "./src/assets/images/section19-list2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-list2.jpg"
            },
            "./src/assets/images/section19-list3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-list3.jpg"
            },
            "./src/assets/images/section19-list4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section19-list4.jpg"
            },
            "./src/assets/images/section2-icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section2-icon1.png"
            },
            "./src/assets/images/section2-icon2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section2-icon2.png"
            },
            "./src/assets/images/section3-1-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-1-mob.jpg"
            },
            "./src/assets/images/section3-1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-1.jpg"
            },
            "./src/assets/images/section3-2-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-2-mob.jpg"
            },
            "./src/assets/images/section3-2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-2.jpg"
            },
            "./src/assets/images/section3-3-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-3-mob.jpg"
            },
            "./src/assets/images/section3-3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-3.jpg"
            },
            "./src/assets/images/section3-4-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-4-mob.jpg"
            },
            "./src/assets/images/section3-4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-4.jpg"
            },
            "./src/assets/images/section3-5-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-5-mob.jpg"
            },
            "./src/assets/images/section3-5.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-5.jpg"
            },
            "./src/assets/images/section3-6-mob.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-6-mob.jpg"
            },
            "./src/assets/images/section3-6.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section3-6.jpg"
            },
            "./src/assets/images/section5-bottom-back.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section5-bottom-back.png"
            },
            "./src/assets/images/section5.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section5.jpg"
            },
            "./src/assets/images/section7-1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section7-1.jpg"
            },
            "./src/assets/images/section7-2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section7-2.jpg"
            },
            "./src/assets/images/section8-1-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-1-mob.png"
            },
            "./src/assets/images/section8-1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-1.png"
            },
            "./src/assets/images/section8-2-mob.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-2-mob.png"
            },
            "./src/assets/images/section8-2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-2.png"
            },
            "./src/assets/images/video-icon.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_video-icon.png"
            },
            "./src/assets/video/section1-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section1-mob.mp4"
            },
            "./src/assets/video/section1.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section1.mp4"
            },
            "./src/assets/video/section10-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10-mob.mp4"
            },
            "./src/assets/video/section10.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section10.mp4"
            },
            "./src/assets/video/section11-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section11-mob.mp4"
            },
            "./src/assets/video/section11.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section11.mp4"
            },
            "./src/assets/video/section12-1-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-1-mob.mp4"
            },
            "./src/assets/video/section12-1.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-1.mp4"
            },
            "./src/assets/video/section12-2-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-2-mob.mp4"
            },
            "./src/assets/video/section12-2.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-2.mp4"
            },
            "./src/assets/video/section12-3-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-3-mob.mp4"
            },
            "./src/assets/video/section12-3.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section12-3.mp4"
            },
            "./src/assets/video/section13-1-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section13-1-mob.mp4"
            },
            "./src/assets/video/section13-1.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section13-1.mp4"
            },
            "./src/assets/video/section13-2-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section13-2-mob.mp4"
            },
            "./src/assets/video/section13-2.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section13-2.mp4"
            },
            "./src/assets/video/section5-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section5-mob.mp4"
            },
            "./src/assets/video/section5.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section5.mp4"
            },
            "./src/assets/video/section6-1-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-1-mob.mp4"
            },
            "./src/assets/video/section6-1.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-1.mp4"
            },
            "./src/assets/video/section6-2-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-2-mob.mp4"
            },
            "./src/assets/video/section6-2.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-2.mp4"
            },
            "./src/assets/video/section6-3-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-3-mob.mp4"
            },
            "./src/assets/video/section6-3.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section6-3.mp4"
            },
            "./src/assets/video/section7-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section7-mob.mp4"
            },
            "./src/assets/video/section7.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section7.mp4"
            },
            "./src/assets/video/section8-1-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-1-mob.mp4"
            },
            "./src/assets/video/section8-1.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-1.mp4"
            },
            "./src/assets/video/section8-2-mob.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-2-mob.mp4"
            },
            "./src/assets/video/section8-2.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/saros10_section8-2.mp4"
            },
            jquery: function(e) {
                "use strict";
                e.exports = $
            }
        },
        t = {};

    function s(i) {
        var o = t[i];
        if (void 0 !== o) return o.exports;
        var n = t[i] = {
            exports: {}
        };
        return e[i](n, n.exports, s), n.exports
    }
    s.m = e, s.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return s.d(t, {
                a: t
            }), t
        }, s.d = function(e, t) {
            for (var i in t) s.o(t, i) && !s.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
            })
        }, s.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, s.p = "/cdn/shop/", s.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            s("./src/index.html"), s("./src/widgets/index.js"), s("./src/js/main.js")
        }()
}();